export const REALTIME_RETRY_ATTEMPTS = Infinity;
export const REALTIME_KEEP_ALIVE_MS = 15_000;
export const REALTIME_ACK_TIMEOUT_MS = 10_000;
export const REALTIME_MAX_RETRY_DELAY_MS = 15_000;
export const REALTIME_RETRY_JITTER_MS = 1_000;

export function computeRealtimeRetryDelay(retries, random = Math.random) {
  const safeRetries = Number.isFinite(retries)
    ? Math.max(0, Math.min(Math.floor(retries), 30))
    : 0;
  const exponentialDelay = Math.min(1_000 * (2 ** safeRetries), REALTIME_MAX_RETRY_DELAY_MS);
  const normalizedRandom = Math.max(0, Math.min(Number(random()) || 0, 0.999999));
  return exponentialDelay + Math.floor(normalizedRandom * REALTIME_RETRY_JITTER_MS);
}

export function waitForRealtimeRetry(retries) {
  return new Promise((resolve) => {
    setTimeout(resolve, computeRealtimeRetryDelay(retries));
  });
}
